import { FeatureConfig } from '@typesApp/Config'

export const baseConfig_USFlow: FeatureConfig = {
  defaultView: 'insurance-member',
  disableInsurerConfigurationInitialFetch: true,
  contactUs: ['phone', 'chat', 'faq'],
}
